export default {
  home: {
    hero: {
      badge: 'Central de recursos de compras 2026',
      title: 'Seu recurso completo de Basetao Spreadsheet',
      subtitle:
        'Encontre planilhas de Basetao úteis, links de produtos, guias de vendedores, dicas de QC e ajuda de envio — tudo organizado em um só lugar.',
      trust: 'Recurso informativo independente para compradores da Basetao.',
      categoryLabel: 'Explorar por categoria',
      categoryPlaceholder: 'Escolha uma categoria…',
    },
    categories: {
      title: 'Comprar por categoria',
      subtitle: 'Vá direto aos produtos que você quer no site principal.',
    },
    intro: {
      eyebrow: 'O que é',
      title: 'O que é uma planilha de Basetao?',
      p1: 'Uma planilha de Basetao é um documento organizado que ajuda você a acompanhar cada produto, vendedor, preço e detalhe de QC enquanto compra pelo agente Basetao.',
      p2: 'Ela mantém seus links, tamanhos, cores e o progresso do envio em um só lugar, para você nunca perder o controle de um pedido nem gastar demais por acidente.',
    },
    features: {
      title: 'Tudo o que você precisa para comprar com mais inteligência',
      subtitle: 'Dos links de produtos à entrega final, mantenha-se organizado em cada etapa.',
      items: [
        {
          title: 'Categorias selecionadas',
          desc: 'Explore 14 categorias de produtos e vá direto ao que você quer.',
        },
        {
          title: 'Guias de vendedores',
          desc: 'Entenda como comparar lojas e escolher vendedores confiáveis.',
        },
        {
          title: 'Dicas de QC',
          desc: 'Saiba o que verificar antes de seus itens saírem do armazém.',
        },
        {
          title: 'Ajuda de envio',
          desc: 'Familiarize-se com os métodos de envio e o básico dos custos.',
        },
      ],
    },
    articleTeaser: {
      eyebrow: 'Guia em destaque',
      title: 'O guia completo de Basetao Spreadsheet',
      desc: 'Aprenda a criar e usar uma planilha de Basetao para organizar links de produtos, vendedores, fotos de QC e detalhes de envio.',
      readMore: 'Ler o guia completo',
    },
    faq: {
      title: 'Perguntas frequentes',
      items: [
        {
          q: 'O que é Basetao Spreadsheet?',
          a: 'É um recurso informativo que organiza links de produtos, categorias e guias de compra para ajudar os compradores da Basetao a encontrar mais rápido o que precisam.',
        },
        {
          q: 'Vocês vendem produtos diretamente?',
          a: 'Não. Nós direcionamos para o site principal, onde você pode explorar e comprar os produtos.',
        },
        {
          q: 'Este é o site oficial da Basetao?',
          a: 'Não. Este é um recurso informativo independente e não é o site oficial da Basetao, salvo indicação explícita em contrário.',
        },
        {
          q: 'Como uso o menu suspenso de categorias?',
          a: 'Abra o menu, escolha uma categoria e você será levado à página correspondente no site principal.',
        },
      ],
    },
    finalCta: {
      title: 'Pronto para explorar os recursos de Basetao Spreadsheet?',
      subtitle: 'Explore as categorias abaixo ou visite o site principal para começar a comprar.',
    },
  },
};